(function () {
  if (window.__sipitCollectionInit) return;
  window.__sipitCollectionInit = true;

  const roots = document.querySelectorAll('.sipit-collection');
  if (!roots.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  function money(amount, format) {
    const value = Number.isFinite(Number(amount)) ? Number(amount) : 0;
    const decimals = value.toFixed(2);
    const noDecimals = Math.round(value).toString();
    if (!format || format.includes('{{')) {
      return '$' + decimals.replace(/\.00$/, '');
    }
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, decimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, decimals.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  async function addItemToCart(variantId, quantity, sellingPlan) {
    const item = {
      id: Number(variantId),
      quantity: Number(quantity) || 1,
    };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);

    const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add to cart.');
    }
    return data;
  }

  function openCartDrawer() {
    const trigger =
      document.querySelector('[data-testid="cart-drawer-trigger"]') ||
      document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) {
      trigger.click();
      return;
    }
    window.location.href = '/cart';
  }

  function flashAdded(btn, original) {
    if (!btn) return;
    btn.innerHTML = btn.dataset.addedText || 'Added ✓';
    btn.style.background = 'var(--teal)';
    btn.style.color = '#062a2d';
    setTimeout(() => {
      btn.innerHTML = original;
      btn.style.background = '';
      btn.style.color = '';
    }, 1300);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function initConfigurableCard(card, root) {
    const config = card.querySelector('[data-sipit-collection-config]');
    const variantsEl = card.querySelector('[data-sipit-collection-variants]');
    if (!config || !variantsEl || config.dataset.sipitCollectionInit === '1') return;
    config.dataset.sipitCollectionInit = '1';

    let variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent || '[]');
    } catch (error) {
      variants = [];
    }
    if (!variants.length) return;

    const packButtons = config.querySelectorAll('[data-sipit-card-pack]');
    const flavorButtons = config.querySelectorAll('[data-sipit-card-flavor]');
    const modeButtons = config.querySelectorAll('[data-sipit-card-mode]');
    const planSelect = config.querySelector('[data-sipit-card-plan]');
    const addButton = config.querySelector('[data-sipit-collection-atc]');
    const cardPrice = card.querySelector('[data-sipit-collection-card-price]');
    const atcPrice = config.querySelector('[data-sipit-card-atc-price]');
    const image = card.querySelector('[data-sipit-collection-card-image], .flavor-img__primary img');
    const primaryFlavorLabel = card.querySelector('[data-sipit-card-primary-label]');
    const packPicker = config.querySelector('[data-sipit-card-pack-picker]');
    const packTrigger = config.querySelector('[data-sipit-card-pack-trigger]');
    const packMenu = config.querySelector('[data-sipit-card-pack-menu]');
    const packCurrent = config.querySelector('[data-sipit-card-pack-current]');
    const selectionSummary = config.querySelector('[data-sipit-card-summary]');
    const selectionSavings = config.querySelector('[data-sipit-card-savings]');
    const moneyFormat = root.dataset.moneyFormat || '$';
    let selectedPack = config.dataset.defaultPack || packButtons[0]?.dataset.sipitCardPack || '';
    let selectedFlavor = config.dataset.defaultFlavor || flavorButtons[0]?.dataset.sipitCardFlavor || '';
    let mode = modeButtons.length ? 'subscribe' : 'onetime';
    let adding = false;

    function findVariant() {
      return (
        variants.find(
          (item) =>
            item.pack === selectedPack &&
            item.flavor === selectedFlavor &&
            item.available
        ) ||
        variants.find((item) => item.pack === selectedPack && item.flavor === selectedFlavor) ||
        variants.find((item) => item.available) ||
        variants[0]
      );
    }

    function variantPrice(variant) {
      if (mode === 'subscribe') {
        const planId = planSelect && planSelect.value;
        if (planId && variant.subscribePrices && variant.subscribePrices[planId] != null) {
          return Number(variant.subscribePrices[planId]);
        }
        if (Number.isFinite(Number(variant.subscribePrice))) {
          return Number(variant.subscribePrice);
        }
      }
      return Number(variant.price);
    }

    function updateImage(variant) {
      if (!variant) return;
      if (primaryFlavorLabel) primaryFlavorLabel.textContent = variant.flavor || '';
      if (!image || !variant.img) return;
      const nextSrc = variant.img;
      const currentSrc = image.getAttribute('src') || '';
      if (currentSrc.split('?')[0] === nextSrc.split('?')[0]) {
        image.alt = `${variant.flavor || ''} ${card.querySelector('h3')?.textContent || ''}`.trim();
        return;
      }

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = nextSrc;
      image.alt = `${variant.flavor || ''} ${card.querySelector('h3')?.textContent || ''}`.trim();
      const swap = new Image();
      swap.decoding = 'async';
      swap.onload = () => {
        image.src = nextSrc;
        image.alt = `${variant.flavor || ''} ${card.querySelector('h3')?.textContent || ''}`.trim();
      };
      swap.onerror = () => {
        image.src = nextSrc;
      };
      swap.src = nextSrc;
    }

    function setPackPickerOpen(open) {
      if (!packMenu || !packTrigger) return;
      packMenu.hidden = !open;
      packTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      packPicker?.classList.toggle('is-open', open);
    }

    function refresh() {
      const variant = findVariant();
      const price = variantPrice(variant);
      const available = Boolean(variant && variant.available);
      const priceText = money(price, moneyFormat);
      const packCount = parseInt(String(selectedPack).match(/\d+/)?.[0] || '1', 10) || 1;
      const singlePouch = variants.find((item) => /\b1\s*Pouch\b/i.test(item.pack));
      const compareTotal = singlePouch ? Number(singlePouch.price) * packCount : price;
      const savings = Math.max(0, compareTotal - price);

      packButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.sipitCardPack === selectedPack);
      });
      flavorButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.sipitCardFlavor === selectedFlavor);
      });
      if (packCurrent) packCurrent.textContent = selectedPack;
      packButtons.forEach((button) => {
        button.setAttribute('aria-selected', button.dataset.sipitCardPack === selectedPack ? 'true' : 'false');
      });
      modeButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.sipitCardMode === mode);
      });
      if (planSelect) {
        planSelect.classList.toggle('is-hidden', mode !== 'subscribe');
        planSelect.disabled = mode !== 'subscribe';
      }
      if (cardPrice) cardPrice.textContent = priceText;
      if (atcPrice) atcPrice.textContent = priceText;
      if (selectionSummary) selectionSummary.textContent = `${selectedPack} · ${selectedFlavor}`;
      if (selectionSavings) {
        selectionSavings.hidden = savings < 0.01;
        selectionSavings.textContent = savings >= 0.01 ? `Save ${money(savings, moneyFormat)}` : '';
      }
      if (addButton) {
        addButton.disabled = !available || adding;
        if (!available) addButton.innerHTML = 'Sold out';
        else if (!adding) addButton.innerHTML = `Add to cart · <span data-sipit-card-atc-price>${escapeHtml(priceText)}</span>`;
      }
      updateImage(variant);
    }

    packButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedPack = button.dataset.sipitCardPack || selectedPack;
        setPackPickerOpen(false);
        refresh();
      });
    });
    flavorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedFlavor = button.dataset.sipitCardFlavor || selectedFlavor;
        refresh();
      });
    });
    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        mode = button.dataset.sipitCardMode || 'onetime';
        refresh();
      });
    });
    if (planSelect) planSelect.addEventListener('change', refresh);

    if (packTrigger && packMenu) {
      packTrigger.addEventListener('click', () => {
        setPackPickerOpen(packMenu.hidden);
      });
      document.addEventListener('click', (event) => {
        if (packPicker && !packPicker.contains(event.target)) setPackPickerOpen(false);
      });
    }

    if (addButton) {
      addButton.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const variant = findVariant();
        if (adding || !variant || !variant.available) return;

        const original = addButton.innerHTML;
        adding = true;
        refresh();
        try {
          const sellingPlan =
            mode === 'subscribe' && planSelect && !planSelect.disabled ? planSelect.value : '';
          await addItemToCart(variant.id, 1, sellingPlan);
          flashAdded(addButton, original);
          openCartDrawer();
        } catch (error) {
          window.alert(error.message || 'Could not add to cart.');
        } finally {
          adding = false;
          refresh();
        }
      });
    }

    refresh();
  }

  roots.forEach((root) => {
    root.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });

    root.querySelectorAll('.product-card--configurable').forEach((card) => {
      initConfigurableCard(card, root);
    });

    root.querySelectorAll('[data-sipit-collection-atc]').forEach((btn) => {
      if (btn.closest('.product-card--configurable')) return;
      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const original = btn.innerHTML;
        const wasDisabled = btn.disabled;
        btn.disabled = true;
        try {
          await addItemToCart(variantId, 1, '');
          flashAdded(btn, original);
          openCartDrawer();
        } catch (error) {
          window.alert(error.message || 'Could not add to cart.');
        } finally {
          if (!wasDisabled) btn.disabled = false;
        }
      });
    });
  });
})();
